import { DEFAULT_HEADERS } from "./defaultClient";

const BASE_URL = process.env.VITE_BACKEND_API_BASE_URL;

async function assertOk(res: Response): Promise<void> {
    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(`Push API error ${res.status}: ${text}`);
    }
}

// TODO: stoplightでyml更新したら置き換える
export const subscribePush = async (
    subscription: PushSubscription,
    csrfToken: string
): Promise<void> => {
    const res = await fetch(`${BASE_URL}/push/subscribe`, {
        method: "POST",
        credentials: "include",
        headers: {
            ...DEFAULT_HEADERS,
            "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ subscription: subscription.toJSON() }),
    });
    await assertOk(res);
};

// TODO: stoplightでyml更新したら置き換える
export const unsubscribePush = async (
    endpoint: string,
    csrfToken: string
): Promise<void> => {
    const res = await fetch(`${BASE_URL}/push/unsubscribe`, {
        method: "DELETE",
        credentials: "include",
        headers: {
            ...DEFAULT_HEADERS,
            "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ endpoint }),
    });
    await assertOk(res);
};

// TODO: あとで削除する
export const testSendPush = async (
    csrfToken: string
): Promise<{ success: number; failed: number }> => {
    const res = await fetch(`${BASE_URL}/push/test-send`, {
        method: "POST",
        credentials: "include",
        headers: {
            ...DEFAULT_HEADERS,
            "X-CSRF-Token": csrfToken,
        },
    });
    await assertOk(res);
    return res.json();
};
